export function generateMediaQueryString({ min, max }: { min?: number; max?: number }): string | undefined {
  if (min && max) {
    return `(min-width: ${min}px) and (max-width: ${max}px)`;
  }
  if (min) {
    return `(min-width: ${min}px)`;
  }
  if (max) {
    return `(max-width: ${max}px)`;
  }
}
